/** @format */

import axios from "axios";
// import alertify from "alertifyjs";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATION = Constantes().ApiConfig.PATH_Courses;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem("userLogin"));
const API = {
  listar: async (id, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINT}${id}`, { headers: headers });
      if (dataUser == undefined) {
        getAlert(Constantes().msmCurso, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(Constantes().msmCurso, "", alertMessage);
      } else if (result.data.detail.courseArray.length == 0) {
        getAlert(Constantes().msmCurso, "", alertMessage);
      }
      return await result.data.detail.courseArray;
    } catch (err) {
      getAlert(Constantes().msmCurso, "./Login");
    }
    // return await (await axios.get(`${ENDPOINT}${id}`, { headers: headers })).data.detail;
  },
};

export default API;
